<script lang="ts" setup>

	import {useI18n} from 'vue-i18n';
  import {computed} from "vue";

  type AvailabilityWindow = Window & {
    syngentaTenant?: boolean;
  };

  const {t} = useI18n();

  const availabilityWindow = window as AvailabilityWindow;

  const isSyngentaTenant = computed(() => availabilityWindow.syngentaTenant === true);

	defineProps<{
		poName: string;
		poNote: string;
		isAddNoteSelected: boolean;
	}>();

	const emit = defineEmits([
		'on-po-name-change',
		'on-add-note-toggle',
		'on-po-note-change'
	]);

	const setPoName = (event: Event) => {
		const target = event.target as HTMLInputElement;
		const cursorStart = target.selectionStart;
		const cursorEnd = target.selectionEnd;

		const newValue = target.value ? target.value.toUpperCase() : '';

		emit('on-po-name-change', newValue);

		target.value = newValue;
		target.setSelectionRange(cursorStart, cursorEnd);
	};

	const toggleAddNoteSelected = () => {
		emit('on-add-note-toggle');
	};

	const setPoNote = (event: Event) => {
		emit('on-po-note-change', (event.target as HTMLInputElement).value);
	};

</script>

<template>
	<div class="input-wrapper">
		<div class="input-wrapper">
			<label for="poname">{{ t('shoppingcart.modal.createpo.content.poName.label') }}:</label>
			<br />
			<input id="poname"
			       :placeholder="t('shoppingcart.modal.createpo.content.poName.maxChars')"
			       :value="poName"
			       maxlength="40"
			       type="text"
			       @input="setPoName" />
		</div>

		<div class="input-wrapper">
			<label class="checkboxwrapper">
				<input :checked="isAddNoteSelected"
				       type="checkbox"
				       @input="toggleAddNoteSelected" />

				<span class="checkbox-icon"></span>
				{{ t('shoppingcart.modal.createpo.content.addNote.label') }}
			</label>
		</div>

		<div v-if="isAddNoteSelected" class="input-wrapper input-wrapper--indent">
			<p class="modal-wrapper__disclaimer">
        {{isSyngentaTenant ? t('site.syngenta.shoppingcart.modal.createpo.content.addNote.disclaimer') : t('shoppingcart.modal.createpo.content.addNote.disclaimer')}}
			</p>

			<div class="message-wrapper">
				<label for="po-comment">{{ t('shoppingcart.modal.createpo.content.note.label') }}</label>
				<textarea id="po-comment" :value="poNote" @input="setPoNote"></textarea>
			</div>
		</div>
	</div>
</template>
